import { useUserStore } from '@/stores'
import { pushAxonEvent } from '@/utils/axonTrack'

export function useAxonPageView() {
  function reportPageView() {
    const userStore = useUserStore()
    pushAxonEvent('page_view', {
      value: userStore.$state.memberId || undefined,
    })
  }

  return { reportPageView }
}
